<div class="indicators-wrapper" *ngIf="indicators.length > 1">
  <span *ngFor="let item of indicators" [class]="getIndicatorClass(item.ref)">{{ item.ref }}</span>
</div>
